import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Router } from '@angular/router';
@Injectable({
  providedIn: "root"
})
export class AppSessionInteruptService {

  constructor(private http: HttpClient, private router:Router) {}

  continueSession() {
    console.log(`I issue an API request to server.`);
  }
  stopSession() {
    console.log(`I logout.`);
    this.router.navigate(['/login']);
    
  }
}
